import { memo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import { getEndpointUrl } from "../../Utils/Common";

const DeleteSection = ({ show, close, data, onCallback }) => {
    const [isLoading, setLoading] = useState(false);

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const onDelete = async () => {
        if (!data?.id) {
            toast.error("Data section tidak valid.", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
            return;
        }

        setLoading(true);
        try {
            const res = await fetch(`${getEndpointUrl()}/v2/form_sections/${data.id}`, {
                method: "DELETE",
                headers: new Headers({
                    Authorization: `Bearer ${accesToken}`,
                }),
            });
            const json = await res.json();
            setLoading(false);

            if (json.status === 'ok') {
                toast.success("Section berhasil dihapus.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });
                onCallback(json.results);
                close();
            } else {
                toast.error(json.message || "Gagal menghapus section.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        } catch (err) {
            setLoading(false);
            toast.error("Terjadi kesalahan jaringan.", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        }
    };

    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={show} onHide={close} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{isLoading ? "Menghapus data..." : "Konfirmasi Hapus Section"}</Modal.Title>
                </Modal.Header>
                {isLoading ? (
                    <div className="d-flex justify-content-center mt-5 mb-5">
                        <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                    </div>
                ) : (
                    <>
                        <Modal.Body>
                            Apakah Anda yakin ingin menghapus section
                            {` "${data?.title || `ID ${data?.id}`}"`}? Tindakan ini tidak dapat dibatalkan.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={close}>Batal</Button>
                            <Button variant="danger" onClick={onDelete}>Hapus</Button>
                        </Modal.Footer>
                    </>
                )}
            </Modal>
        </>
    );
};

export default memo(DeleteSection);